<template>
  <div>
    <div class="alert alert-danger alert-dismissible" role="alert" v-show="error">
       <div>{{ error }}</div>
       <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click.prevent="error = ''"></button>
    </div>

    <div class="login-form" v-if="success">
      <p class="reset-password-title">Reset your password</p>
      <p class="reset-password-text">Your password has been reset</p>
    </div>

    <div class="login-form" v-else>
      <p class="reset-password-title">Reset your password</p>
      <p class="reset-password-text">Almost done. Enter your new password and you are good to go.</p>

      <form @submit.prevent="onSubmit">
        <div class="input-form">
          <div class="password-input-group">
            <p class="input-label">New Password</p>
            <input class="input" v-model="form.password" type="password" required />
            <p class="invalid-label" v-show="hasInvalidPassword"><img src="@/assets/error.png" />{{ invalidPasswordLabel }}</p>
          </div>

          <div class="password-input-group">
            <p class="input-label">Confirm New Password</p>
            <input class="input" v-model="form.confirmPassword" type="password" required />
            <p class="invalid-label" v-show="hasInvalidPassword"><img src="@/assets/error.png" />{{ invalidPasswordLabel }}</p>
          </div>
        </div>

        <b-button class="form-button" type="submit" variant="primary">Submit</b-button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    const urlParams = new URLSearchParams(window.location.search)
    this.code = urlParams.get('code')
    this.id = urlParams.get('id')
  },
  data(){
    return {
      code: '',
      id: '',
      form: {
        password: '',
        confirmPassword: ''
      },
      hasInvalidPassword: false,
      success: false,
      invalidPasswordLabel: '',
      error: ''
    }
  },
  methods: {
    async onSubmit() {
      if (this.form.password != this.form.confirmPassword){
        this.hasInvalidPassword = true;
        this.invalidPasswordLabel = 'Confirm password did not match'
        return;
      }
      
      if (this.form.password.length < 8) {
        this.hasInvalidPassword = true;
        this.invalidPasswordLabel = 'Password must have at least 8 characters'
        return;
      }

      var response_json = await this.resetPassword()
      if (response_json.status === "fail") {
        this.hasInvalidPassword = false
        this.error = `Reset password failed: ${response_json.message}`
      } else {
        this.hasInvalidPassword = false
        this.form.password = ''
        this.success = true;
      }
    },
    async resetPassword() {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 'newPassword': this.form.password }),
        redirect: 'follow'
      };

      return await fetch(`https://oauth${process.env.VUE_APP_DEPLOY_ENV === 'LIVE' ? '' : '-stage'}.fanscore.com/users/${this.id}/resetPassword?code=${this.code}`, requestOptions)
        .then(response => response.json())
        .then(data => {
          return data
        })
        .catch(error => {
          console.log('error', error)
        });
    }
  }
}
</script>

<style>
.reset-password-text {
  text-align: left;
}
.alert-danger {
  margin-top: 24px;
  margin-left: 24px;
  margin-right: 24px;
}
</style>